import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as API from '../api';

const selectedCustomerSlice = createSlice({
  name: 'selectedCustomerSlice',
  initialState: {
    isFetching: false,
    customer: {},
    error: null,
  },
  reducers: {
    selectedCustomerRequestFailed: (store) => {
      store.isFetching = false;
    },
    selectedCustomerRequestFinished: (store, action) => {
      store.customer = action.payload.data.customer;
      store.isFetching = false;
      store.error = null;
    },
    selectedCustomerRequested: (store) => {
      store.isFetching = true;
      store.error = null;
    },
  },
});

export const { selectedCustomerRequestFailed, selectedCustomerRequested, selectedCustomerRequestFinished } = selectedCustomerSlice.actions;
export default selectedCustomerSlice.reducer;

export const fetchCustomer = createAsyncThunk('customer/customerData', async ({ customerId }, { dispatch }) => {
  try {
    dispatch(selectedCustomerRequested());
    const data = await API.fetchCustomerForEdit(customerId);
    dispatch(selectedCustomerRequestFinished(data));
  } catch (error) {
    dispatch(selectedCustomerRequestFailed(error));
  }
});
